import React from "react";

const experience = [
  {
    type: "work",
    date: "Aug 2025 – Nov 2025",
    title: "Mobile App Developer (Part-Time)",
    org: "TanAinent Global UK LTD",
    orgLink: "https://apps.apple.com/app/rahiee-ai",
    badge: "Live on App Store",
    badgeColor: "#4ade80",
    points: [
      "Sole mobile developer — built Rahiee.AI, an AI-powered HR management app, targeting both Android (Gradle, Android SDK) and iOS (Xcode, CocoaPods, iOS SDK) from a single Flutter codebase.",
      "Owned the complete iOS app lifecycle: Xcode project configuration, CocoaPods dependency management, iOS provisioning profiles & signing certificates, TestFlight beta distribution, and full App Store Connect submission pipeline.",
      "Navigated Apple Review policy queries (FCM vs. advertisement classification), resolved compliance blockers, and successfully shipped the app live on the Apple App Store.",
      "Implemented real-time attendance tracking, employee management, schedule management, and performance analytics using Firebase Firestore & FCM push notifications.",
      "Managed Google Play Console pipeline: app signing, staged rollouts, release tracks, and Play Store compliance.",
    ],
    tags: ["Flutter","Dart","iOS SDK","Android SDK","Xcode","CocoaPods","Firebase","GetX","App Store Connect","Google Play Console"],
  },
];

const education = [
  {
    type: "edu",
    date: "Sept 2022 – May 2026",
    title: "BSc in Computer Science & Engineering",
    org: "Islamic University of Technology (IUT)",
    badge: "GPA 3.39 / 4.0",
    badgeColor: "#a78bfa",
    points: [
      "Relevant Coursework: Data Structures & Algorithms, OOP, Database Management, Software Engineering, Computer Architecture, System Analysis & Design.",
      "Active member of the IUT Software Development Club and competitive programming community.",
      "Part of Project Altair — IUT's team in the International Mars Rover Competition (Software Subteam).",
    ],
    tags: ["Computer Science","DSA","OOP","Software Engineering"],
  },
];

function TimelineItem({ item }) {
  return (
    <div className="tl-item">
      <div className="tl-dot" />
      <div className="tl-card">
        {/* Header row */}
        <div className="tl-header">
          <div>
            <span className="tl-date">{item.date}</span>
            <h3 className="tl-title">{item.title}</h3>
            {item.orgLink ? (
              <a href={item.orgLink} target="_blank" rel="noreferrer" className="tl-org">
                {item.org} ↗
              </a>
            ) : (
              <span className="tl-org">{item.org}</span>
            )}
          </div>
          <span className="tl-badge" style={{ background: `${item.badgeColor}18`, color: item.badgeColor, border: `1px solid ${item.badgeColor}40` }}>
            {item.badge}
          </span>
        </div>

        {/* Bullet points */}
        <ul className="tl-points">
          {item.points.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>

        {/* Tags */}
        <div className="tl-tags">
          {item.tags.map((t) => (
            <span className="timeline-tag" key={t}>{t}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

function ExperienceSection() {
  return (
    <section id="experience" className="sp-section">
      <div className="sp-container">
        <div className="sp-section-header">
          <span className="section-label">My Journey</span>
          <h2 className="section-title">
            Experience &amp; <span className="gradient-text">Education</span>
          </h2>
        </div>

        <div className="tl-grid">
          {/* Work */}
          <div>
            <h3 className="tl-col-title">
              <span className="tl-col-icon">💼</span> Work Experience
            </h3>
            <div className="timeline">
              {experience.map((e, i) => <TimelineItem item={e} key={i} />)}
            </div>
          </div>

          {/* Education */}
          <div>
            <h3 className="tl-col-title">
              <span className="tl-col-icon">🎓</span> Education
            </h3>
            <div className="timeline">
              {education.map((e, i) => <TimelineItem item={e} key={i} />)}
            </div>

            {/* Open Source highlight */}
            <div className="oss-card">
              <div className="oss-card-icon">📦</div>
              <div>
                <div className="oss-card-title">Open-Source Arduino Library</div>
                <div className="oss-card-sub">Published to the official Arduino Library Manager</div>
                <p className="oss-card-text">
                  Plug-and-play wireless bridge between ESP32/ESP8266 & HC-05/HC-06 and Android — zero boilerplate
                  setup for developers building wireless robot controllers.
                </p>
                <a href="https://github.com/sakibahmedshanto/RoboLink" target="_blank" rel="noreferrer" className="oss-link">
                  View on GitHub ↗
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;
